/**
 * Утилиты для работы с часовыми поясами
 * Поддерживает динамические timezone для разных регионов
 */

/**
 * Возвращает ISO строку с timezone устройства
 * 
 * ВАЖНО: Использует РЕАЛЬНЫЙ timezone устройства, а не хардкод MSK!
 * Это позволяет корректно работать с объектами в разных часовых поясах.
 * 
 * @param date - Дата для конвертации (по умолчанию текущее время)
 * @returns ISO строка с timezone устройства (например, "2026-02-02T15:44:14.992+03:00")
 */
export function toISOStringWithTimezone(date: Date = new Date()): string {
  // Получаем timezone offset в минутах
  const offsetMinutes = -date.getTimezoneOffset()
  
  // Вычисляем timezone в формате +HH:MM или -HH:MM
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60)
  const offsetMins = Math.abs(offsetMinutes) % 60
  const sign = offsetMinutes >= 0 ? '+' : '-'
  const timezone = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`
  
  // Форматируем дату в локальном времени устройства
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  const ms = String(date.getMilliseconds()).padStart(3, '0')
  
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${ms}${timezone}`
}

/**
 * @deprecated Используйте toISOStringWithTimezone() для поддержки разных timezone
 * Оставлено для обратной совместимости
 */
export function toMSKISOString(date: Date = new Date()): string {
  return toISOStringWithTimezone(date)
}
